import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { results } from "@/mocks/results";

const typeStyles: Record<string, string> = {
  警告并整改: "bg-secondary-100 text-secondary-900 border-secondary-200",
  限制开播: "bg-primary-100 text-primary-900 border-primary-200",
  内容下架: "bg-background-200 text-foreground-800 border-background-300",
  退还差额: "bg-accent-100 text-accent-900 border-accent-200",
  账号封禁: "bg-primary-200 text-primary-950 border-primary-300",
};

export default function ResultsSection() {
  const latest = results.slice(0, 5);

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <SectionHeading
          eyebrow="处理结果公示"
          title="核查结束，结果公开可查"
          description="处置类型、完成时间与处理摘要全部对外展示，举报人与关注者都能核对自己的线索最终走到了哪一步。"
        />
        <Link
          to="/results"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-md text-sm font-medium bg-foreground-950 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap shrink-0"
        >
          进入结果公示区
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <ul className="mt-10 border border-background-200 rounded-lg overflow-hidden divide-y divide-background-200 bg-background-100">
        {latest.map((item) => (
          <li key={item.id} className="p-4 md:p-5 hover:bg-background-50 transition-colors">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-5 md:items-center">
              <div className="md:col-span-6 min-w-0">
                <h3 className="font-heading text-base font-bold text-foreground-950 leading-snug">
                  {item.eventId ? (
                    <Link to={`/events/${item.eventId}`} className="hover:text-primary-600 transition-colors">
                      {item.title}
                    </Link>
                  ) : (
                    item.title
                  )}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500">
                  {item.platform} · {item.category}
                </p>
              </div>
              <div className="md:col-span-3">
                <span
                  className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full border text-xs font-medium whitespace-nowrap ${
                    typeStyles[item.resultType] ?? "bg-background-200 text-foreground-800 border-background-300"
                  }`}
                >
                  <i className="ri-scales-3-line" aria-hidden="true"></i>
                  {item.resultType}
                </span>
              </div>
              <div className="md:col-span-3 md:text-right text-xs text-foreground-500">
                {item.handledAt} 完成 · 用时 {item.cycle}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}